// extracted by mini-css-extract-plugin
module.exports = {"header":"NotFoundPage_header__3rhNV","hero_text_box":"NotFoundPage_hero_text_box__4mH9k","btn":"NotFoundPage_btn__2STEu"};